import Constants from "../../constants";
import IdentityService from "./indentity.service";

interface IRequestGetAllTenant {
    searchText?: string;
}

class TenantService extends IdentityService {
    public getAll = async (data?: IRequestGetAllTenant): Promise<any[]> => {
        const result = await this.api.get({
            path: Constants.ApiPath.TENANT.GET_ALL,
            query: data,
        });
        return result.data.result;
    };
}

export default TenantService;
